import React, { FC, useEffect } from 'react'
import { ComponentResourceTabs } from '../../../models/components/resourceTabs'
import { ResourceTabsContainer } from './style'

//* components
import Typography from '../../global/typography'
import GlobalContainer from '../globalContainer'
import { ResourceTabContent } from './subcomponent'

type Props = {
  data: ComponentResourceTabs
}

const ResourceTabs: FC<Props> = ({ data }) => {
  const resourceTabsData = {
    id: data.id || '',
    headline: data.headline || '',
    tab1: {
      one: data.tab1 || '',
      primary: data.tab1Primary || '',
      secondary: data.tab1Secondary || '',
      robotUrl: data.tab1Robot?.image?.file?.url || '',
      robotAltText: data.tab1Robot?.altText || '',
    },
    tab2: {
      two: data.tab2 || '',
      primary: data.tab2Primary || '',
      secondary: data.tab2Secondary || '',
      robotUrl: data.tab2Robot?.image?.file?.url || '',
      robotAltText: data.tab2Robot?.altText || '',
    },
    tab3: {
      three: data.tab3 || '',
      primary: data.tab3Primary || '',
      secondary: data.tab3Secondary || '',
      robotUrl: data.tab3Robot?.image?.file?.url || '',
      robotAltText: data.tab3Robot?.altText || '',
    },
  }

  const allTabs = [
    resourceTabsData.tab1.one,
    resourceTabsData.tab2.two,
    resourceTabsData.tab3.three,
  ]

  const allTabData = [
    {
      tab1Primary: resourceTabsData.tab1.primary,
      tab1Secondary: resourceTabsData.tab1.secondary,
      tab1Robot: resourceTabsData.tab1.robotUrl,
      tab1RobotAlt: resourceTabsData.tab1.robotAltText,
    },
    {
      tab2Primary: resourceTabsData.tab2.primary,
      tab2Secondary: resourceTabsData.tab2.secondary,
      tab2Robot: resourceTabsData.tab2.robotUrl,
      tab2RobotAlt: resourceTabsData.tab2.robotAltText,
    },
    {
      tab3Primary: resourceTabsData.tab3.primary,
      tab3Secondary: resourceTabsData.tab3.secondary,
      tab3Robot: resourceTabsData.tab3.robotUrl,
      tab3RobotAlt: resourceTabsData.tab3.robotAltText,
    },
  ]

  let allItems: NodeListOf<Element>
  let allTabsElem: NodeListOf<Element>

  const resetAll = () => {
    for (let i = 0; i < allItems.length; i++) {
      allItems[i].classList.remove('active')
      allTabsElem[i].classList.remove('activeTab')
    }
  }

  const onClickHandler = (e: any) => {
    resetAll()
    e.target.classList.add('activeTab')
    allItems[e.target.dataset.idx].classList.add('active')
  }

  useEffect(() => {
    if (typeof document !== undefined) {
      allTabsElem = document.querySelectorAll(
        `.ResousceTabs__Personas#Resource-Tabs-Outer--${resourceTabsData.id} > li`
      )
      allItems = document.querySelectorAll(
        `.ResourceTabs__All-Content#Resource-Tabs-Content--${resourceTabsData.id} > .ResourceTabs__Content-Container`
      )
    }
  }, [])

  return (
    <ResourceTabsContainer data-cy="ResourceTabs">
      <GlobalContainer className="ResourceTabs__Outer-Container">
        {resourceTabsData.headline && (
          <Typography type="header2">{resourceTabsData.headline}</Typography>
        )}

        <ul className="ResousceTabs__Personas" id={`Resource-Tabs-Outer--${resourceTabsData.id}`}>
          {allTabs.map((val, idx) => {
            return (
              <li
                data-idx={idx}
                key={`${resourceTabsData.id}--tab-${idx}`}
                onClick={onClickHandler}
                {...(idx === 0 ? { className: 'activeTab' } : {})}>
                {val}
              </li>
            )
          })}
        </ul>

        <ResourceTabContent resourceTabsData={resourceTabsData} allTabData={allTabData} />
      </GlobalContainer>
    </ResourceTabsContainer>
  )
}

export default ResourceTabs
